import { Injectable } from '@angular/core';
import { Event, InlineCheckout, ModalCheckout } from '@bambora/checkout-sdk-web';

@Injectable()
export class KlarnaCheckoutService {

  constructor() {
  }

  public insertSnippet(snippet, container: Element) {
    // This is necessary otherwise the scripts tags are not going to be evaluated
    if (!container) {
      console.warn('Not possible to put Klarna snippet, container is ', container);
      return;
    }

    container.innerHTML = snippet;
    const scriptTags = container.getElementsByTagName('script');

    Array.from(scriptTags).forEach((tag) => {
      const { parentNode } = tag;
      const newScriptTag = document.createElement('script');

      newScriptTag.type = 'text/javascript';
      newScriptTag.text = tag.text;

      parentNode.removeChild(tag);
      parentNode.appendChild(newScriptTag);
    });
  }
}
